import * as React from "react";
import { merge, $ } from "glamor";
import classNames from "classnames";
import { toDataTest } from "helpers/test";

interface ILink {
    component?: string;
    displayName: string;
    path?: string;
}

interface IProps {
    links: ILink[];
    brandEntities: any;
    scope: any;
    router: any;
}

export class ProductCollectionBreadcrumbs extends React.PureComponent<IProps, any> {
    private styles = merge(
        {
            display: "flex",
            alignItems: "center",
            flexGrow: "1",
            padding: "8px",
        },
        $(" .breadcrumbLink", {
            fontSize: "14px",
            color: "#585858",
        }),
        $(" a.breadcrumbLink", {
            textDecoration: "underline",
        }),
        $(" .selected", {
            color: "#2d2d2d",
            fontWeight: "bold",
        }),
        $(" .separator", {
            padding: "0 6px",
            fontSize: "14px",
        }),
        $(" .afterBrandPickerSeparator", {
            paddingLeft: "1px",
        }),
        $(" .brandName", {
            padding: "0 !important",
        }),
        $(" .brandName svg", {
            width: "18px",
            height: "18px",
        })
    );

    render() {
        const { links, brandEntities, scope, router } = this.props;

        const formattedLinks =
            links.length <= 1
                ? []
                : links.map((link: ILink, index) => {
                      const isLastLink = !links[index + 1];
                      const href = isLastLink ? undefined : link.path;
                      return (
                          <React.Fragment key={`frag_${index}`}>
                              {href && (
                                  <a
                                      data-test={`breadcrumb-${toDataTest(link.displayName)}`}
                                      className={classNames("breadcrumbLink", { selected: isLastLink })}
                                      href={href}
                                  >
                                      {link.displayName}
                                  </a>
                              )}
                              {!href && (
                                  <div
                                      data-test={`breadcrumb-${toDataTest(link.displayName)}`}
                                      className={classNames("breadcrumbLink", { selected: isLastLink })}
                                  >
                                      {link.displayName}
                                  </div>
                              )}
                              {!isLastLink && (
                                  <div key={`separator_${index}`} className="separator">
                                      /
                                  </div>
                              )}
                          </React.Fragment>
                      );
                  });

        if (!formattedLinks.length) {
            return null;
        }

        return (
            <div {...this.styles} className="breadcrumbsContainer">
                {formattedLinks}
            </div>
        );
    }
}
